stripTrailingSlash